import { render, staticRenderFns } from "./BomDetailList.vue?vue&type=template&id=1fbd9840"
import script from "./BomDetailList.vue?vue&type=script&lang=js"
export * from "./BomDetailList.vue?vue&type=script&lang=js"
import style0 from "./BomDetailList.vue?vue&type=style&index=0&id=1fbd9840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports